import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Layout } from "@/components/layout/Layout";
import { Button } from "@/components/ui/button";
import { ShieldAlert, Home, ArrowRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const NotFound = () => {
  const location = useLocation();
  const { language, isRTL } = useLanguage();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  const content = {
    he: {
      title: "404",
      subtitle: "אופס! נראה שהגעתם לאזור ללא ציוד מגן...",
      message: "הדף שחיפשתם לא נמצא. אל דאגה, בואו נחזור לדף הבית בבטחה.",
      button: "חזרה לדף הבית",
    },
    en: {
      title: "404",
      subtitle: "Oops! Looks like you've entered an unprotected zone...",
      message: "The page you're looking for doesn't exist. Don't worry, let's get you back home safely.",
      button: "Back to Home",
    },
  };

  const t = content[language];
  const ArrowIcon = isRTL ? ArrowRight : ArrowRight;

  return (
    <Layout>
      <div className="min-h-[70vh] flex items-center justify-center bg-gradient-to-b from-background to-muted/30 px-4">
        <div className="text-center max-w-lg mx-auto">
          {/* Safety Icon */}
          <div className="mb-8 flex justify-center">
            <div className="relative">
              <div className="w-32 h-32 rounded-full bg-primary/10 flex items-center justify-center animate-pulse-glow">
                <ShieldAlert className="w-16 h-16 text-primary" />
              </div>
              <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-accent flex items-center justify-center text-accent-foreground font-bold text-sm">
                !
              </div>
            </div>
          </div>

          {/* 404 Number */}
          <h1 className="text-8xl md:text-9xl font-heading font-bold text-primary mb-4">
            {t.title}
          </h1>

          {/* Subtitle */}
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground mb-4">
            {t.subtitle}
          </h2>

          {/* Message */}
          <p className="text-muted-foreground text-lg mb-8 leading-relaxed">
            {t.message}
          </p>

          {/* Back to Home Button */}
          <Button asChild variant="cta" size="lg" className="gap-2">
            <Link to="/">
              <Home className="w-5 h-5" />
              {t.button}
              <ArrowIcon className={`w-4 h-4 ${isRTL ? 'rotate-180' : ''}`} />
            </Link>
          </Button>

          {/* Decorative Elements */}
          <div className="mt-12 flex justify-center gap-2">
            {[...Array(3)].map((_, i) => (
              <div
                key={i}
                className="w-2 h-2 rounded-full bg-primary/30"
                style={{ animationDelay: `${i * 0.2}s` }}
              />
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;
